module.exports = __webpack_public_path__ + "static/media/newUser.c2d89c6b.svg";